(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["erl-custom-announcement-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.eab__slider').forEach((slider) => {
    const speed = parseFloat(slider.dataset.speed) || 5;
    const slides = slider.querySelectorAll('.eab__slide');
    slides.forEach((slide, i) => {
      slide.style.setProperty('--eab-speed', `${speed * slides.length}s`);
      slide.style.animationDelay = `${i * speed}s`;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["erl-custom-header-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="eh-search-toggle-"]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = document.getElementById(btn.id.replace('eh-search-toggle-', 'eh-search-panel-'));
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (panel) {
        panel.hidden = expanded;
        if (!expanded) {
          const input = panel.querySelector('input');
          if (input) input.focus();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["erl-custom-hero-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ehr').forEach((hero) => {
    const slides = hero.querySelectorAll('.ehr__slide');
    const dots = hero.querySelectorAll('.ehr__dot');
    let current = 0;
    let timer;

    function goTo(index) {
      slides[current]?.classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current]?.classList.add('is-active');
      dots[current]?.classList.add('is-active');
    }

    hero.querySelector('.ehr__arrow--next')?.addEventListener('click', () => goTo(current + 1));
    hero.querySelector('.ehr__arrow--prev')?.addEventListener('click', () => goTo(current - 1));
    dots.forEach((dot) => dot.addEventListener('click', () => goTo(parseInt(dot.dataset.goto, 10))));

    if (hero.dataset.autoplay === 'true' && slides.length > 1) {
      const speed = (parseFloat(hero.dataset.speed) || 6) * 1000;
      timer = setInterval(() => goTo(current + 1), speed);
      hero.addEventListener('mouseenter', () => clearInterval(timer));
      hero.addEventListener('mouseleave', () => {
        timer = setInterval(() => goTo(current + 1), speed);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
